import { dateEnUS, dateFaIR, enUS, faIR } from 'naive-ui';
import type { NDateLocale, NLocale } from 'naive-ui';

export const naiveLocales: Record<App.I18n.LangType, NLocale> = {
  'fa-IR': faIR,
  'en-US': enUS
};

export const naiveDateLocales: Record<App.I18n.LangType, NDateLocale> = {
  'fa-IR': dateFaIR,
  'en-US': dateEnUS
};
